import { themePalette } from '@theme/muiTheme';
import styled from 'styled-components';

export const MultiSelectionBadgeStyled = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
  padding: 0 8px 0 14px;
  margin-right: 16px;
  border-radius: 999px;
  background: ${themePalette.green[500]};
  white-space: nowrap;
  user-select: none;
`;

export const ClearButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  cursor: pointer;
  border: none;
  background: transparent;
  line-height: 0;
`;
